import { Stack, Typography, Chip } from '@mui/material'
import { MedicalActRecord } from '@/core/models/medical-act.model'
import { formatPrice } from '../model/useMedicalActRecords'

export type MedicalActRecordCompactItemProps = {
    record: MedicalActRecord
}

export function MedicalActRecordCompactItem({ record }: MedicalActRecordCompactItemProps) {
    const templateName = typeof record.template === 'object' ? record.template.name : 'Unknown Act'

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ py: 0.5, px: 1, bgcolor: 'grey.50', borderRadius: 1 }}
        >
            <Typography variant="body2" noWrap sx={{ flex: 1 }}>
                {templateName}
            </Typography>
            <Chip
                label={formatPrice(record.priceAtTime)}
                size="small"
                variant="outlined"
            />
        </Stack>
    )
}
